import {
  useLazyOmniChatSessionHistories,
  useLazyOmniChatSessionSupervisorHistories,
  useLazyOmniChatSessionSupervisorInprogress
} from 'hooks';
import React, { createContext, useEffect } from 'react';
import { ChatSessionDto, FindAllChatSessionsHistoryDto } from 'types';
import { useContext } from 'react';
import dayjs from 'dayjs';
import { SearchType } from 'components/omni-channel-chat-histories/OmniChannelLeadChatHistoriesFilterForm';
import {
  offReceiveChatSessionInProgress,
  offRemoveChatSessionInProgress,
  onReceiveChatSessionInProgress,
  onRemoveChatSessionInProgress
} from 'services';

export type OmniHistoriesLeadManageContextProps = {
  chatSession?: ChatSessionDto;
  setChatSession: (chatSession: ChatSessionDto | undefined) => void;

  chatOngoing?: ChatSessionDto;
  setChatOngoing: (chatSession: ChatSessionDto | undefined) => void;

  chatHistory?: ChatSessionDto;
  setChatHistory: (chatSession: ChatSessionDto | undefined) => void;

  tab: TabChatManagementKeys;
  setTab: (tab: TabChatManagementKeys) => void;

  searchChatSessions: (value?: Partial<FindAllChatSessionsHistoryDto>) => void;
  chatSessionHistories: {
    date: string;
    sessions: ChatSessionDto[];
  }[];
  chatSessionOngoing: ChatSessionDto[];
  isLoadingOngoing: boolean;
  isLoadingHistories: boolean;
  isFetchingHistories?: boolean;
  countHistories?: number;
  countOngoing?: number;
  hasMoreHistories: boolean;
  hasMoreOngoing: boolean;
  handleLoadMoreHistories: () => void;
  handleLoadMoreOngoing: () => void;

  originalArgsHistories?: Partial<FindAllChatSessionsHistoryDto>;
  originalArgsOngoing?: Partial<FindAllChatSessionsHistoryDto>;

  validateHistory: boolean;
  searchType: SearchType;
  setSearchType: (type: SearchType) => void;
};

export enum TabChatManagementKeys {
  ONGOING = 'ongoing',
  HISTORY = 'history',
  ASSIGN = 'assign'
}

export const OmniHistoriesLeadManageProviderContext = createContext<OmniHistoriesLeadManageContextProps | undefined>(
  undefined
);

export const OmniHistoriesLeadManageProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [chatSession, setChatSession] = React.useState<ChatSessionDto | undefined>(undefined);
  const [chatOngoing, setChatOngoing] = React.useState<ChatSessionDto | undefined>(undefined);
  const [chatHistory, setChatHistory] = React.useState<ChatSessionDto | undefined>(undefined);
  const [tab, setTab] = React.useState<TabChatManagementKeys>(TabChatManagementKeys.ASSIGN);
  const [validateHistory, setValidateHistory] = React.useState<boolean>(true);
  const [searchType, setSearchType] = React.useState<SearchType>(SearchType.CUSTOMER);

  const {
    originalArgs: originalArgsHistories,
    count: countHistories,
    groupedData: groupedDataHistories,
    isLoading: isLoadingHistories,
    hasMore: hasMoreHistories,
    fetchData: fetchDataHistories,
    handleLoadMore: handleLoadMoreHistories,
    isFetching: isFetchingHistories
  } = useLazyOmniChatSessionSupervisorHistories();

  const {
    originalArgs: originalArgsOngoing,
    count: countOngoing,
    groupedData: groupedDataOngoing,
    isLoading: isLoadingOngoing,
    hasMore: hasMoreOngoing,
    fetchData: fetchDataOngoing,
    handleLoadMore: handleLoadMoreOngoing,
    isFetching: isFetchingOngoing,
    data: dataResponseOngoing
  } = useLazyOmniChatSessionSupervisorInprogress();

  useEffect(() => {
    onReceiveChatSessionInProgress(() => {});
    onRemoveChatSessionInProgress(() => {});

    return () => {
      offReceiveChatSessionInProgress();
      offRemoveChatSessionInProgress();
    };
  }, []);

  const searchChatSessions = (value?: Partial<FindAllChatSessionsHistoryDto>) => {
    if (tab === 'history') {
      // if (!value?.customerId && !value?.extensionId) {
      //   setValidateHistory(true);
      //   return;
      // }
      setValidateHistory(false);
      fetchDataHistories(value);
    } else {
      fetchDataOngoing(value);
    }
  };

  return (
    <OmniHistoriesLeadManageProviderContext.Provider
      value={{
        chatSession: chatSession,
        setChatSession: setChatSession,

        chatOngoing: chatOngoing,
        setChatOngoing: setChatOngoing,

        chatHistory: chatHistory,
        setChatHistory: setChatHistory,

        searchChatSessions: searchChatSessions,
        chatSessionHistories: groupedDataHistories,
        chatSessionOngoing: dataResponseOngoing || [],

        isLoadingOngoing: isLoadingOngoing || isFetchingOngoing,
        isLoadingHistories: isLoadingHistories,
        isFetchingHistories: isFetchingHistories,
        // isLoadingHistories: isLoadingHistories || isFetchingHistories,
        countHistories: countHistories,
        countOngoing: countOngoing,
        hasMoreHistories: hasMoreHistories,
        hasMoreOngoing: hasMoreOngoing,
        handleLoadMoreHistories: handleLoadMoreHistories,
        handleLoadMoreOngoing: handleLoadMoreOngoing,

        originalArgsHistories: originalArgsHistories,
        originalArgsOngoing: originalArgsOngoing,

        validateHistory,
        tab,
        setTab,

        searchType,
        setSearchType
      }}
    >
      {/* <Spin className='max-h-full overflow-hidden' spinning={isLoading || isFetching}> */}
      {children}
      {/* </Spin> */}
    </OmniHistoriesLeadManageProviderContext.Provider>
  );
};
export default OmniHistoriesLeadManageProvider;

export const useOmniHistoriesLeadManageContext = (): OmniHistoriesLeadManageContextProps => {
  const context = useContext(OmniHistoriesLeadManageProviderContext);
  if (!context) {
    throw new Error('useOmniHistoriesLeadManageContext must be used within a OmniHistoriesProvider');
  }
  return context;
};
